import { Component, OnInit } from '@angular/core';
import { HashComponent } from '../hash/hash.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';

@Component({
  selector: 'app-find-hash',
  templateUrl: './find-hash.component.html',
  styleUrls: ['../hash/hash.component.css', './find-hash.component.css']
})
export class FindHashComponent extends HashComponent {

  openElement: any = undefined;
  clicked = [];

  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected messageService: MessageService) {
    super(activatedRoute, topicService, messageService)
  }

  setTypeSpecificsFromConfiguration() {
    super.setTypeSpecificsFromConfiguration();

    this.clicked = [];
    let oldPrecomputation = this.precomputationS;
    this.hashElements = true;
    for (let element of this.elements) {
      let precomputed = undefined;
      let elem = {
        value: element,
        precomputed: precomputed,
        operation: undefined,
        scaled: undefined,
        hash: undefined
      };
      this.selected = elem;
      if (this.elementType == 'number') {
        this.precomputationS = element.toString().split("").join(",");
        this.changePrecomputation(true);
      } else {
        this.precomputationS = element.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
        this.changePrecomputation(true);
      }
      this.hashElement(this.hashed.length - 1, false);
    }
    this.hashElements = false;
    this.precomputationS = oldPrecomputation;
    this.selected = {
      value: this.configuration.typespecifics.requiredElement,
      precomputed: undefined,
      operation: undefined,
      scaled: undefined,
      hash: undefined,
      test: 1
    }
    if (this.elementType == 'number') {
      this.precomputationS = this.selected.value.toString().split("").join(",");
      this.changePrecomputation();
    } else {
      if (this.compute.includes('precomputation')) {
        this.precomputationS = this.selected.value.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
        this.changePrecomputation();
      }
    }
  }

  computeState() {
    super.computeState();
    this.state.typespecific.requiredElement = this.selected;
    this.state.typespecific.openElement = this.openElement;
    this.state.typespecific.clicked = this.clicked;
  }

  setTypeSpecificsFromState() {
    super.setTypeSpecificsFromState();
    if (this.state.typespecific != undefined && this.state.typespecific.requiredElement != undefined) {
      this.selected = this.state.typespecific.requiredElement;
    }
    if (this.state.typespecific != undefined && this.state.typespecific.openElement != undefined) {
      this.openElement = this.state.typespecific.openElement;
    }
    if (this.state.typespecific != undefined && this.state.typespecific.clicked != undefined) {
      this.clicked = this.state.typespecific.clicked;
    }
  }


  /** compute all cards that might need to be opened to find the correct card and check if more cards where opened */
  checkFind(test: boolean = false): boolean {
    let toClick = [];
    let elem = {
      value: this.selected.value,
      precomputed: undefined,
      operation: undefined,
      scaled: undefined,
      hash: undefined,
    }
    let oldSelected = this.selected;
    let oldPrecomputation = this.precomputationS;
    this.selected = elem;
    if (this.elementType == 'number') {
      this.precomputationS = this.selected.value.toString().split("").join(",");
      this.changePrecomputation(true);
    } else {
      this.precomputationS = this.selected.value.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
      this.changePrecomputation(true);
    }
    if (!this.linearProbing) {
      toClick = this.hashed[elem.hash].map(v => v.value);
    } else {
      let i = this.selected.hash;
      while (this.hashed[i % this.divisor].length > 0 && this.hashed[i % this.divisor][0].value != this.selected.value) {
        toClick.push(this.hashed[i % this.divisor][0].value);
        i++;
      }
      if (this.hashed[i % this.divisor].length > 0) {
        toClick.push(this.hashed[i % this.divisor][0].value);
      }
    }
    let error = false;
    for (let value of this.clicked) {
      if (!toClick.includes(value)) {
        error = true;
      }
    }

    if (error && !test) {
      this.messageService.addAlertWithTimeout(this.get("TooManyCardsOpened"), "danger", 10000);
    } else if(!test){
      this.messageService.addAlertWithTimeout(this.get("correctNumberOfCards"), "success", 10000);
    }
    this.selected = oldSelected;
    this.precomputationS = oldPrecomputation;
    return error;
  }

  /** opens a card and checks for match */
  open(element: any) {
    this.openElement = element;
    this.clicked.push(element.value);
    if (element.value == this.selected.value) {
      this.messageService.addAlertWithTimeout(this.get("foundElement"), "success", 10000);
      this.solved = true;
      this.checkFind();
      this.state.solved = true;
      this.saveState();
    }
  }

  /** When clicking "not existing", check if this is true, and show corresponding message */
  notExisting() {
    if (this.elements.includes(this.selected.value)) {
      this.messageService.addAlertWithTimeout(this.get("YetExisting"), "danger", 10000);
      let elem = {
        value: this.selected.value,
        precomputed: undefined,
        operation: undefined,
        scaled: undefined,
        hash: undefined,
      }
      let oldSelected = this.selected;
      let oldPrecomputation = this.precomputationS;
      this.selected = elem;
      if (this.elementType == 'number') {
        this.precomputationS = this.selected.value.toString().split("").join(",");
        this.changePrecomputation(true);
      } else {
        this.precomputationS = this.selected.value.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
        this.changePrecomputation(true);
      }
      this.selected = oldSelected;
      this.precomputationS = oldPrecomputation;
      if (elem.hash != this.selected.hash) {
        this.messageService.addAlertWithTimeout(this.get("CheckHashValue"), "danger", 10000);
      }
      return;
    }

    this.messageService.addAlertWithTimeout(this.get("CorrectlyNotFound"), "success", 10000);
    this.checkFind();
    this.solved = true;
    this.state.solved = true;
    this.saveState();
  }

  checkSolution() {
    this.messageService.addAlertWithTimeout(this.get("NotFoundYet"), "danger", 10000);
    let elem = {
      value: this.selected.value,
      precomputed: undefined,
      operation: undefined,
      scaled: undefined,
      hash: undefined,
    }
    let oldSelected = this.selected;
    let oldPrecomputation = this.precomputationS;
    this.selected = elem;
    if (this.elementType == 'number') {
      this.precomputationS = this.selected.value.toString().split("").join(",");
      this.changePrecomputation(true);
    } else {
      this.precomputationS = this.selected.value.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
      this.changePrecomputation(true);
    }
    this.selected = oldSelected;
    this.precomputationS = oldPrecomputation;
    if (elem.hash != this.selected.hash) {
      this.messageService.addAlertWithTimeout(this.get("CheckHashValue"), "danger", 10000);
    }
  }

  evaluate(): number[] {
    let oldSelected = this.selected;
    let oldPrecomputationS = this.precomputationS;
    let result = 0;
    let maxPoints = 0;
    if (!this.solved) {
      return [0,1];
    }
    let temp = {
      value: this.selected.value,
      precomputed: undefined,
      operation: undefined,
      scaled: undefined,
      hash: undefined
    };
    this.selected = temp;
    if (this.elementType == 'number') {
      this.precomputationS = this.selected.value.toString().split("").join(",");
    } else {
      this.precomputationS = this.selected.value.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
    }
    this.changePrecomputation(true);
    if (this.elementType != 'number' && !this.compute.includes('precomputation') && this.selected.precomputed == oldSelected.precomputed) {
      result += 0.1;
    }
    if(this.elementType == 'number'){
      maxPoints += 0.1;
    }
    if (this.typeFunction != 'digits' && this.typeFunction!="checksum") {
      if (!this.compute.includes('operation') && this.selected.operation == oldSelected.operation) {
        result += 0.1;
      }
      if (!this.compute.includes('scale') && this.selected.scaled == oldSelected.scaled) {
        result += 0.1;
      }
      if (!this.compute.includes('modulo') && this.selected.hash == oldSelected.hash) {
        result += 0.1;
      }
    } else {
      if (!this.compute.includes('operation') && this.selected.hash == oldSelected.hash) {
        result += 0.1;
      }
    }
    maxPoints += 0.3-(0.1*this.compute.length);

    if (!this.checkFind(true)) {
      result += 0.1;
    }
    maxPoints += 0.1;

    this.selected = oldSelected;
    this.precomputationS = oldPrecomputationS;
    return [result, maxPoints];
  }
}
